import { render, staticRenderFns } from "./BatchSetting.vue?vue&type=template&id=a268ac2a&scoped=true&"
import script from "./BatchSetting.vue?vue&type=script&lang=js&"
export * from "./BatchSetting.vue?vue&type=script&lang=js&"
import style0 from "./BatchSetting.vue?vue&type=style&index=0&id=a268ac2a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a268ac2a",
  null
  
)

export default component.exports